module.exports = __webpack_public_path__ + "static/media/2_The inner voice_FA.dfb7a8f3.txt";